// 岗位管管理
import request from '@/utils/request'
// /post/save
// 添加
export function addRank(data) {
  return request({
    url: '/post/save',
    method: 'post',
    data
  })
}

// /post/delete/{id}
// 删除
export function del(id) {
  return request({
    url: '/post/delete/' + id,
    method: 'delete'
  })
}

// /post/update
// 修改
export function edit(data) {
  return request({
    url: '/post/update',
    method: 'put',
    data
  })
}
/**
* 季度添加 / 修改
* @param {*} data
*/
export function addQuarter(data) {
  return request({
      url: '/quarter',
      method: 'post',
      data
  })
}
/**
* 季度通过id删除
*/
export function delQuarter(id) {
  return request({
      url: `/quarter/${id}`,
      method: 'delete',
  })
}
/**
* 季度查看详情
*/
export function getQuarter(id) {
  return request({
      url: `/quarter/${id}`,
      method: 'get'
  })
}
/**
* 季度修改
* @param {*} params
*/
export function editQuarter(params) {
  return request({
      url: '/quarter',
      method: 'put',
      data: params
  })
}